export const environment = {
    production: false,
    api: {
        url: 'https://eval-sso-api-uat.gagroup.com',
        key: 'api://6b1944d6-72b1-4e01-b09f-46d6d10f3e73/access_as_user'
    },
    azure: {
        clientId: '6b1944d6-72b1-4e01-b09f-46d6d10f3e73',
        tenantId: '0572d83d-670a-4c41-acc5-9c92a5121245',
        redirectUri: '/landing',
        authority: 'https://login.microsoftonline.com/',
        scopes: ['User.Read'],
        graph: {
            apiUrl: 'https://graph.microsoft.com/v1.0/me',
            scopes: ['User.Read']
        }
    },
    contractorLoginUrl: 'https://eval-uat.gagroup.com/default.aspx'
};
